import { connect } from 'react-redux';
import RequestPayment from 'account/components/payout/request_payment';
import { sumAwards, filterAvailableAwards } from 'common/ducks/payout';

const mapStateToProps = ({ payout }) => ({
  balance: sumAwards(filterAvailableAwards(payout.pendingAwards))
});

export default connect(mapStateToProps, {
})(RequestPayment);



// WEBPACK FOOTER //
// ./account/containers/payout/request_payment.js